var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 4",
    cx: 18.3473,
    cy: 18.0498,
    rx: 17.5437,
    ry: 17.5746,
    fill: "#0B161A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDot);
export default __webpack_public_path__ + "static/media/pin-dot.2cd7bc6679c53cabbf2902f6ece45809.svg";
export { ForwardRef as ReactComponent };